module.exports = __webpack_public_path__ + "img/art-work-icon3.a4495f77.png";